module.exports = __webpack_public_path__ + "static/media/naagii.ca4af180.png";